import { I18n } from "@/i18n/I18n";
import { ProjectCards } from "../cards/ProjectCards";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { useEffect, useState } from "react";
import { CardPlaceholder } from "../cards/CardPlaceholder";
import { useShallow } from "zustand/react/shallow";
import { ProjectParentType } from "@/backend/models/project";

export function AllProjects() {
  const fetchAllProjects = useProjectStore(state => state.fetchAllProjects);
  const projects = useProjectStore(useShallow(state => state.projects.filter(project => project.parentType === ProjectParentType.WORKSPACE)));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    void fetchAllProjects().finally(() => {
      setLoading(false);
    });
  }, [fetchAllProjects]);

  if (loading) {
    return <CardPlaceholder />;
  }

  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className="pb-3">
        <h1>{I18n.get('projectsUppercase')}</h1>
      </div>
      <ProjectCards projects={projects} parentType={ProjectParentType.WORKSPACE} />
    </div>
  );
}
